module.exports = __webpack_public_path__ + "img/website-mock.31947f2d.png";